document.addEventListener('DOMContentLoaded', () => {
  const isAllCollection = location.pathname === '/collections/all';
  if (!isAllCollection) {
    document.querySelectorAll('.img-sirusi').forEach(el => {
      el.style.display = 'none';
    });
  }
});
